import { render } from "./InfractionDetailsContainer.vue?vue&type=template&id=5401d351&scoped=true"
import script from "./InfractionDetailsContainer.vue?vue&type=script&lang=js"
export * from "./InfractionDetailsContainer.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./InfractionDetailsContainer.vue?vue&type=style&index=0&id=5401d351&scoped=true&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-5401d351"]])

export default __exports__